import styled from 'styled-components';

export const Label = styled.div`
  font-size: 14px;
  line-height: 1.2;
  justify-content: center;
  display: inline-flex;
  align-items: center;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border: 1px solid;
  border-color: #e7e7e8;
  border-right: none;
  padding-inline-start: 0.75rem;
  padding-inline-end: 0;
  border-radius: 0.375rem 0 0 0.375rem;
`;
